/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.presentationModule')
  .directive('bulbPresentationFooter', ['$timeout', '$window', 'BulbPresentationService', bulbPresentationFooter]);

function bulbPresentationFooter($timeout, $window, BulbPresentationService) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/presentation/presentationfooter.html',
    controller: 'PresentationFooterController as presentationFooterCtrl',
    scope: true,
    link: function link(scope, element, attrs) {
      const footerInner = jQuery('#presentation-footer-inner');
      const footerInnerHeight = footerInner.outerHeight();
      const footerShowBtn = jQuery('#footer-show-btn');
      const footerHideBtn = jQuery('#footer-hide-btn');
      const scrollContainer = jQuery('#presentation-footer-thumbnail-scroll-container');
      const scrollPrevBtn = jQuery('#presentation-footer-thumbnail-move-btn-prev');
      const scrollNextBtn = jQuery('#presentation-footer-thumbnail-move-btn-next');
      let thumbnailsVisible = false;
      let lastThumbnailsVisible = false;

      scope.presentationService = BulbPresentationService;

      const footerDuration = 200;
      scope.showFooter = function () {
        footerInner.stop().animate({
          top: -footerInnerHeight,
        }, {
          duration: footerDuration,
        });
        footerShowBtn.hide();
        footerHideBtn.show();
        if (lastThumbnailsVisible) {
          scope.showThumbnails();
        }
      };

      scope.hideFooter = function () {
        footerInner.stop().animate({
          top: 0,
        }, {
          duration: footerDuration,
        });
        footerShowBtn.show();
        footerHideBtn.hide();
        lastThumbnailsVisible = thumbnailsVisible;
        if (thumbnailsVisible) {
          scope.hideThumbnails();
        }
      };

      const initScrollButton = function () {
        scrollPrevBtn.hide();
        const scrollBar = scrollContainer.parent().find('.ps__scrollbar-x').eq(0);
        const scrollBarWidth = scrollBar.width();
        if (scrollBarWidth === 0) {
          scrollNextBtn.hide();
          scrollPrevBtn.hide();
        } else {
          if (scrollContainer.scrollLeft() > 0) {
            scrollPrevBtn.show();
          } else {
            scrollPrevBtn.hide();
          }

          if (scrollBar.position().left + scrollBar.width() < scrollContainer.outerWidth()) {
            scrollNextBtn.show();
          } else {
            scrollNextBtn.hide();
          }
        }
      };

      let scrollButtonInitialized = false;
      const thumbnailDuration = 200;
      scope.showThumbnails = function () {
        thumbnailsVisible = true;
        jQuery('#presentation-footer-thumbnail-container').stop().fadeIn(thumbnailDuration);
        const scrollBarContainer = jQuery('#presentation-footer-thumbnail-inner-container').children().eq(0)[0];
        $window.Ps.update(scrollBarContainer);

        // show current page thumbnail
        const { left } = jQuery('#current-thumbnail-cover').offset();
        const xScrollBar = jQuery(scrollBarContainer).find('.ps__scrollbar-x').eq(0);
        const scrollBarLeft = xScrollBar.offset().left;
        const scrollBarWidth = xScrollBar.width();
        const paddingLeft = jQuery(scrollBarContainer).css('padding-left');
        const tmp = left - parseInt(paddingLeft) - 10;
        if (scrollBarLeft + scrollBarWidth < tmp) {
          scrollBarContainer.scrollLeft = tmp;
          $window.Ps.update(scrollBarContainer);
        }

        if (!scrollButtonInitialized) {
          initScrollButton();
          scrollButtonInitialized = true;
        }
      };

      scope.hideThumbnails = function () {
        thumbnailsVisible = false;
        jQuery('#presentation-footer-thumbnail-container').stop().fadeOut(thumbnailDuration);
      };

      scope.toggleThumbnails = function () {
        thumbnailsVisible = !thumbnailsVisible;
        if (thumbnailsVisible) {
          scope.showThumbnails();
        } else {
          scope.hideThumbnails();
        }
      };

      const scrollThumbnail = function (next) {
        const left = scrollContainer.scrollLeft();
        const moveAmount = (next ? 1 : -1) * scrollContainer.width() * 0.9;
        scrollContainer.animate({
          scrollLeft: left + moveAmount,
        }, {
          progress: function progess() {
            $window.Ps.update(scrollContainer.get(0));
          },
        });
      };

      scope.scrollPrev = function () {
        scrollThumbnail(false);
      };

      scope.scrollNext = function () {
        scrollThumbnail(true);
      };

      const onOrientationChange = function () {
        $timeout(() => {
          BulbPresentationService.restoreZoom();
          BulbPresentationService.zoom();
          jQuery('#presentation-footer-thumbnail-scroll-container').removeAttr('bulb-themed-scrollbar');

          $timeout(() => {
            scrollContainer.attr('bulb-themed-scrollbar');
            $window.Ps.update(scrollContainer.get(0));
            scrollButtonInitialized = false;
            if (thumbnailsVisible) {
              scope.showThumbnails();
            }
          }, 0);
        }, 500);
      };

      jQuery($window).on('orientationchange', onOrientationChange);

      scope.$on('$destroy', () => {
        jQuery($window).off('orientationchange', onOrientationChange);
      });

      $timeout(() => {
        scope.$watch(() => {
          // On a page change, we need to explicitly set the 'zoomed' value to false. Otherwise when changing to another page
          // While already in presentation mode, the service won't apply the css changes to the content allowing it to look
          // Like we are in presentation mode.
          BulbPresentationService.zoomed = false;
          return BulbPresentationService.zoomed;
        }, (zoomedInitialized) => {
          // If we are already in fullscreen mode, that means the user is switching the page for which they are
          // Presenting
          if (BulbPresentationService.isFullScreen()) {
            if (!zoomedInitialized) {
              if (!BulbPresentationService.zoomed) {
                BulbPresentationService.zoom();
              }
            }
          }
        });
      }, (BulbPresentationService.firstTimePresenting) ? 500 : 0);

      scope.hideFooter();
      $timeout(() => {
        scope.showFooter();
      }, 500);

      // init thumbnail scroll
      scrollContainer.parent().on('ps-scroll-x', () => {
        scrollPrevBtn.show();
        scrollNextBtn.show();
      });

      scrollContainer.parent().on('ps-x-reach-start', () => {
        scrollPrevBtn.hide();
      });

      scrollContainer.parent().on('ps-x-reach-end', () => {
        scrollNextBtn.hide();
      });

      /**
       * Deregistration function that upon loading of the svg source from the ng-include, will find every article
       * within the scrollContainer, the container that houses the bulb-block-tiles, and will navigate to that page
       * If the user clicks that article.
       *
       * @type {*|(function())}
       */
      var destroyThumbnailInit = scope.$on('$includeContentLoaded', (event) => {
        destroyThumbnailInit();
        $timeout(() => {
          scrollContainer.find('article').click((event) => {
            scope.hideThumbnails();
            const unit = BulbPresentationService.parentUnit.children
            .find((child) => child.id === event.currentTarget.id);
            BulbPresentationService.changePage(unit);
          });
        });
      });
    },
  };
}
